import Feedback from "./Main"

window.feedback = new Feedback()
